import * as actions from './actions';
import types, { moduleName } from './types';

export { actions as default, moduleName as NAME, types };
